import {Injectable} from '@angular/core';
import {additionalSitesStore, Site, ValidationSummaryType} from './add-sites.store';
import {addEntities, deleteEntities, setEntities, updateAllEntities, updateEntities} from '@ngneat/elf-entities';
import {setProps} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class AdditionalSitesManager {
  public setLoading(value: boolean) {
    additionalSitesStore.update(setProps({isLoading: value}));
  }

  public addSite(site: Site) {
    additionalSitesStore.update(addEntities(site));
  }

  public updateValidationSummaryType(id: string, type: ValidationSummaryType) {
    additionalSitesStore.update(updateEntities(id, {type}));
  }

  public setSites(siteList: Site[]) {
    additionalSitesStore.update(setEntities(siteList));
  }

  public removeSite(id: string) {
    additionalSitesStore.update(deleteEntities(id));
  }

  public reset() {
    additionalSitesStore.reset();
  }

  public markAllSiteLoaded() {
    additionalSitesStore.update(updateAllEntities(entity => ({...entity, loading: false})));
  }
}
